import { useEffect, useState } from "react";
import errorImg from "../images/pages/bg-error.jpg";
import logoBlack from "../images/logo-black-horizontal.png";
import "./EmailConfirmation.css";
import { Link, useLocation } from "react-router-dom";
import localeText from "../../locale";

const isValidURL = (str) => {
  try {
    new URL(str);
    return true;
  } catch (e) {
    return false;
  }
};

const EmailConfirmation = ({ title, message, type, url = "" }) => {
  const [typeText, setTypeText] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idProductCart = searchParams.get("idProductCart");

  const loginUrl = idProductCart ? `/cart?idProductCart=${idProductCart}` : "/login";
  const loginLabel = idProductCart ? localeText("loginAndContinuePurchase") : localeText("doLogin");

  useEffect(() => {
    if (type === "error") {
      document.getElementById("exception-image").style.background = "url(" + errorImg + ")";
      document.getElementById("exception-image").style.backgroundSize = "cover";
      setTypeText(localeText("error").toUpperCase());
    } else if (type === "success") {
      document.getElementById("exception-image").style.background =
        "linear-gradient(#46a748, #272360)";
      document.getElementById("exception-image").style.backgroundSize = "cover";
      setTypeText(localeText("success").toUpperCase());
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="exception-image" className="exception-body">
      <div className="exception-panel"></div>
      <div className="exception-content p-3 flex align-items-start">
        <div className="card ml-4 mr-4 pb-8 pt-8 msg-card-responsive">
          <Link to="/">
            <img src={logoBlack} alt="babylon-layout" style={{ width: "270px" }} />
          </Link>
          <h1 className="text-700 pb-4">{typeText}</h1>
          <h3 className="text-900">{title}</h3>
          <p style={{ maxWidth: "570px" }}>{message}</p>
          {isValidURL(url) && (
            <div>
              <a
                href={url}
                className="p-button"
                style={{
                  padding: "0.75rem 2rem",
                  marginBottom: "16px",
                  backgroundColor: "#1976d2",
                  color: "#ffffff",
                  border: "1px solid #1565c0",
                  textDecoration: "none",
                  borderRadius: "4px",
                  fontWeight: "500",
                  fontSize: "16px",
                  display: "inline-block",
                }}
                target="_blank"
                rel="noopener noreferrer"
                download={true}
              >
                {localeText("download")}
              </a>
            </div>
          )}
          <div>
            <p
              style={{
                fontSize: "14px",
                marginBottom: "16px",
              }}
            >
              {localeText("doubts")}
            </p>
            <div
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                marginBottom: "16px",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              <a
                target="_blank"
                style={{
                  backgroundColor: "#25D366",
                  color: "#ffffff",
                  padding: "0.375rem 0.75rem",
                  borderRadius: "4px",
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: "12px",
                  fontWeight: "500",
                  border: "1px solid #22C55E",
                  transition: "background-color 0.3s ease",
                }}
                href="https://wa.me/message/AALEU6LSOPNWM1"
                rel="noreferrer"
              >
                <i className="pi pi-whatsapp" style={{ fontSize: "14px" }} />
                WhatsApp
              </a>
            </div>
          </div>
          <Link
            to={loginUrl}
            className="p-button text-white"
            style={{ padding: "0.5rem 1rem", marginBottom: "16px", display: "inline-block", textDecoration: "none" }}
          >
            {loginLabel}
          </Link>
          <br />
          <Link to="/">{localeText("backToHomePage")}</Link>
        </div>
        <div className="msg-card">
          <Link to="/">
            <img src={logoBlack} alt="babylon-layout" style={{ width: "270px" }} />
          </Link>
          <h1 className="text-700 pb-4">{typeText}</h1>
          <h3 className="text-900">{title}</h3>
          <p style={{ maxWidth: "570px" }}>{message}</p>
          {isValidURL(url) && (
            <div>
              <a
                href={url}
                className="p-button"
                style={{
                  padding: "0.75rem 2rem",
                  marginBottom: "14px",
                  backgroundColor: "#1976d2",
                  color: "#ffffff",
                  border: "1px solid #1565c0",
                  textDecoration: "none",
                  borderRadius: "4px",
                  fontWeight: "500",
                  fontSize: "16px",
                  display: "inline-block",
                }}
                target="_blank"
                rel="noopener noreferrer"
                download={true}
              >
                {localeText("download")}
              </a>
            </div>
          )}
          <p style={{ fontSize: "14px", marginBottom: "0" }}>{localeText("emailCanBeSpam")}</p>

          <p style={{ fontSize: "14px", marginBottom: "16px" }}>{localeText("doubts")}</p>
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              marginBottom: "16px",
              flexWrap: "wrap",
            }}
          >
            <a
              target="_blank"
              style={{
                backgroundColor: "#25D366",
                color: "#ffffff",
                padding: "0.375rem 0.75rem",
                borderRadius: "4px",
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "12px",
                fontWeight: "500",
                border: "1px solid #22C55E",
                transition: "background-color 0.3s ease",
              }}
              href="https://wa.me/message/AALEU6LSOPNWM1"
              rel="noreferrer"
            >
              <i className="pi pi-whatsapp" style={{ fontSize: "14px" }} />
              WhatsApp
            </a>
          </div>
          <Link
            to={loginUrl}
            className="p-button text-white"
            style={{ padding: "0.5rem 1rem", marginBottom: "16px", display: "inline-block", textDecoration: "none" }}
          >
            {loginLabel}
          </Link>
          <br />
          <Link to="/">{localeText("backToHomePage")}</Link>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmation;
